import Rails from "@rails/ujs";

if (!window._rails_loaded) {
  Rails.start();
}

import '../stylesheets/application_user.scss';
import Turbolinks from "turbolinks";
import "@rails/activestorage";
// Sprocketsから移行
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';
import { createApp } from 'vue'

window.$ = $;
window.jQuery = $;

const components = import.meta.glob('../modules/**/*.js');

if (!window.__esiApplicationInitialized) {
  window.__esiApplicationInitialized = true;

  Turbolinks.start();

  const mountedApps = new Map();
  let mountGeneration = 0;

  const unmountVueApps = () => {
    mountGeneration += 1;
    mountedApps.forEach((app) => {
      app.unmount();
    });
    mountedApps.clear();
  };

  // Turbolinks がロードされたときにイベントリスナーを設定
  document.addEventListener('turbolinks:load', () => {
    const loadGeneration = mountGeneration;
    // `data-vue` 属性を持つすべての DOM 要素を取得
    const templates = document.querySelectorAll('[data-vue]');

    // 各 `data-vue` 要素に対してループを実行
    templates.forEach(el => {
      if (mountedApps.has(el)) {
        mountedApps.get(el).unmount();
        mountedApps.delete(el);
      }

      // `data-vue` 属性の値を取得し、コンポーネント名として使用
      const componentName = el.dataset.vue;
      let componentFound = false;

      // `components` 内のすべてのファイルパスを調べ、コンポーネント名に一致するファイルを見つける
      for (const path in components) {
        // ファイルパスがコンポーネント名で終わっているか確認
        if (path.endsWith(`${componentName}.js`)) {
          componentFound = true;
          components[path]().then(module => {
            if (loadGeneration !== mountGeneration) return;
            if (!document.contains(el)) return;

            if (mountedApps.has(el)) {
              mountedApps.get(el).unmount();
              mountedApps.delete(el);
            }

            const app = createApp(module.default);
            app.config.compilerOptions.whitespace = 'preserve';
            app.mount(el);
            mountedApps.set(el, app);
          });
          break;  // コンポーネントが見つかったらループを終了
        }
      }

      if (!componentFound) {
        console.warn(`[Vue] data-vue="${componentName}" に対応するモジュールが見つかりません`);
      }
    });
  });

  document.addEventListener('turbolinks:before-cache', () => {
    unmountVueApps();
  });
}
